export enum ExamTypeMode {
  Extraordinary = "extraordinary",
  Recurring = "recurring",
}
